import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type TablePaginationProps = {
  paginationElement?: React.ReactNode;
  wrapperClassName?: string;
};

export const TablePagination = ({
  paginationElement,
  wrapperClassName,
}: TablePaginationProps) => {
  if (!paginationElement) return null;

  return (
    <div
      className={cnTwMerge("py-4 w-full", wrapperClassName)}
      data-testid="table-pagination"
    >
      <div className="w-full" data-testid="pagination-content">
        {paginationElement}
      </div>
    </div>
  );
};
